// Temporary kill-switch for group events (Viðburðir). Flip to true to restore.
export const EVENTS_ENABLED = false;
